import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, of, Subject, pipe } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { ResponseWrapper } from '@library/common/http';

import { CacheService } from '@library/core/services';
import { RelativeDateService } from '@library/common/datehandler';

import { ReportListItem } from './list/report-list-item';

@Injectable({
   providedIn: 'root'
})
export class ReportListService {

   url = `report/manager`;

   refresh$: Subject<void> = new Subject();

   constructor(
      public rdate: RelativeDateService,

      private http: HttpClient,
      private cache: CacheService,
   ) { }

   list(): Observable<ReportListItem[]> {
      return this.cache.request<ResponseWrapper<ReportListItem>, ReportListItem[]>({
         url: this.url,
         refresher: this.refresh$,
         pipe: pipe(
            map( rw => rw.response.collection ),
            map( list => list.map( r => new ReportListItem( r ))),
            map( list => list.sort(( a, b ) => a.pinned ? -1 : b.pinned ? 1 : 0 )),
         ),
      });
   }

   pin( id: number ): Observable<boolean> {
      if ( !id ) { return of( false ); }

      return this.http.post<ResponseWrapper>( this.url + '/pin', { report_id: id }).pipe(
         map( rw => !rw.messages.length ),
         tap( _ => this.cache.expire( this.url )),
      );
   }

   unpin( id: number ): Observable<boolean> {
      if ( !id ) { return of( false ); }

      return this.http.delete<ResponseWrapper>( this.url + '/pin/' + id ).pipe(
         map( rw => !rw.messages.length ),
         tap( _ => this.cache.expire( this.url )),
      );
   }

   delete( id: number ): Observable<boolean> {
      if ( !id ) { return of( false ); }

      return this.http.delete<ResponseWrapper>( this.url + '/' + id ).pipe(
         map( rw => !rw.messages.length ),
         tap( _ => this.cache.expire( this.url )),
      );
   }

   reset() { }
}
